import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Residents from "@/pages/Residents";
import Letters from "@/pages/Letters";
import News from "@/pages/News";
import KartuKeluarga from "@/pages/KartuKeluarga";
import WilayahDesa from "@/pages/WilayahDesa";
import SmartScannerPage from "@/pages/SmartScannerPage";
import DokumenSaya from "@/pages/DokumenSaya";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="h-10 w-10 rounded-full border-4 border-[#064E3B] border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-right" richColors duration={2500} />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/setup" element={<Protected><Setup /></Protected>} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="warga" element={<Residents />} />
              <Route path="kartu-keluarga" element={<KartuKeluarga />} />
              <Route path="wilayah" element={<WilayahDesa />} />
              <Route path="scanner" element={<SmartScannerPage />} />
              <Route path="dokumen" element={<DokumenSaya />} />
              <Route path="surat" element={<Letters />} />
              <Route path="berita" element={<News />} />
              <Route path="pengaturan" element={<Settings />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
